import { isValidElement, type ReactNode } from 'react';

import { stripHtmlTags } from '@/app/utils/format';

const renderNodeToText = (node: ReactNode): string => {
  if (node === null || node === undefined || typeof node === 'boolean')
    return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(renderNodeToText).join(' ');

  if (!isValidElement(node)) return '';

  const { type, props } = node as React.ReactElement<{
    children?: ReactNode;
    dangerouslySetInnerHTML?: { __html: string };
  }>;

  if (typeof type === 'string') {
    if (props.dangerouslySetInnerHTML?.__html !== undefined) {
      return stripHtmlTags(props.dangerouslySetInnerHTML.__html);
    }
    const children =
      props.children !== undefined ? renderNodeToText(props.children) : '';
    if (type === 'li') return `- ${children}`;
    return children;
  }

  if (typeof type === 'function') {
    try {
      return renderNodeToText((type as (props: unknown) => ReactNode)(props));
    } catch {
      return props.children !== undefined
        ? renderNodeToText(props.children)
        : '';
    }
  }

  return '';
};

export const reactNodeToSchemaHtml = (node: ReactNode): string => {
  if (!node) return '';
  if (typeof node === 'string') return stripHtmlTags(node);
  return renderNodeToText(node).replace(/\s+/g, ' ').trim();
};
